import React, { useEffect, useState } from 'react';
import Carousel from './Carousel/Carousel';
import Breathable from '../assets/img/breathable.png';
import Antistatic from '../assets/img/antistatic.png';
import UPF from '../assets/img/upf50.png';
import Local from '../assets/img/local.png';
import footerBanner from '../assets/img/footerbanner.png';
import LoaderImg from  '../assets/img/xpo_loader.gif';
import TabsPage from './TabsPage';

const Home = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [banners, setBanners] = useState([]); // State to store banner data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage errors
  useEffect(() => {
    // Fetch data from the API
    fetch(`${apiBaseUrl}getbanners`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.banners);
        setBanners(data.banners);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message); // Set error if any
        setLoading(false); // Set loading to false even on error
      });
  },[]);
  const style = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(185 201 85)',
    zIndex: 9999
  };

  if (loading) {
    return <div style={style}><img src={LoaderImg} alt='loaders' style={{width:"150px"}}/></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <Carousel images={banners} />
      <div className='container mt-4'>
        <div className='row justify-content-center'>
          <TabsPage/>
        </div>
        <div className='row mt-4'>
          <div className='col-md-12 mb-3 text-center'>
            <h3>THE XPO QUALITY</h3>
          </div>
          <div className='col-md-4 mb-3'>
            <img src={Breathable} className='quality_img img-fluid' alt='breathable'/>
          </div>
          <div className='col-md-4 mb-3'>
            <img src={Antistatic} className='quality_img img-fluid' alt='antistatic'/>
          </div>
          <div className='col-md-4 mb-3'>
            <img src={UPF} className='quality_img img-fluid' alt='upf_50'/>
          </div>
          <div className='col-12 mt-5'>
            <img src={Local} className='mx-auto d-block img-fluid' alt='local'/>
          </div>
          <div className='col-12 mt-5'>
            <img src={footerBanner} className='mx-auto d-block img-fluid' alt='local'/>
          </div>
        </div>
      </div>
      <div className='container mt-4'>
        <div className='row'>
          <div className='offset-md-3 col-md-6'>
            <div className='row'>
              <form method='post'>
                <div className='col-md-12 mb-3'>
                  <label><strong>Name</strong></label>
                  <input type='text' required className='form-control' name='name' placeholder='Name'/>
                </div>
                <div className='col-md-12 mb-3'>
                  <label><strong>Phone</strong></label>
                  <input type='tel' required className='form-control' name='phone' placeholder='+91'/>
                </div>
                <div className='col-md-12 mb-3'>
                  <label><strong>Email</strong></label>
                  <input type='email' required className='form-control' name='email' placeholder='Email'/>
                </div>
                <div className='col-md-12 mb-3'>
                  <label><strong>T-shirt</strong></label>
                  <select className='form-control' name='tshirt' id='tshirt' required>
                      <option value="">Select T-shirt</option>
                      <option value="Full Sleeve">Full Sleeve</option>
                      <option value="Half Sleeve">Half Sleeve</option>
                      <option value="Polo">Polo</option>
                  </select>
                </div>
                <div className='col-md-12 mb-3'>
                  <label><strong>Size</strong></label>
                  <select className='form-control' name='size' id='size' required>
                      <option value="">Select Size</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                  </select>
                </div>
                <div className='col-md-12 mb-3'>
                  <label><strong>Quantity</strong></label>
                  <input type='number' required className='form-control' name='qty' placeholder='Quantity'/>
                </div>
                <div className='col-md-12 mb-3 text-center'>
                  <button type="submit" className='btn btn-outline-primary'>SUBMIT</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
